const PERMISSION_LIST = {
    ENTITY_DETAIL_DASHBOARD:"entity_detail_dashboard",
    ENTITY_DETAIL :'entity_detail',
    ADDRESS :'address',
    AUTHORISEDPERSON :'authorised_person',
    BORROWING :'borrowing',
    SHAREHOLDING :'shareholding',
    MASTERNAME :'masterName',
    MASTERVALUES :'master_values',
    DEAL_DETAIL :'deal_detail',
    DROPDOWN_KEY :'dropdown_key',
    DROPDOWN_VALUES :'dropdown_values',
    PERMISSIONS :'permissions',
    ROLESPERMISSIONS :'roles_permissions',
    ROLES :'roles',
    APICONFIGURATION :'api_configuration',
    SYSTEMCONFIGURATION :'system_configuration',
    TEMPLATEMASTEREMAIL :'template_master_email',
    TEMPLATEMASTERNOTIFICATION :'template_master_notification',
    TEMPLATEMASTERSMS :'template_master_sms',
    COMMERCIALS :'commercials',
    DEAL_FINANCIER :'deal_financier',
    ADD_FIN_USER:'add_financier_user',
    WORKFLOW :'workflow',
    QUERY:'query',
    ADD_PARTNER:'add_partner',
    ADD_PARTNER_USER:'add_partner_user',
    ADD_CI_USER:'add_ci_user',
    PENDING_TASK_TAB: 'pending_tasks_tab',
    SCHEDULED_MEETING_TAB: 'scheduled_meetings_tab',
    NOTES_TAB:'notes_tab',
    REQ_CONSENT:'req_consent',
    PLATFORM_USER:'platform_user',
    ENTITY_BULK_UPLOAD :'entity_bulk_upload',
    FINANCIER_OPERATIONS:'financier_operations',
    DEAL_SUMMARY :'deal_summary',
    DOWNLOAD_EXCEL_DATA: 'download_excel_data'
}

const PERMISSION_STATUS = {
    ALLOWED :1,
    DENY:0,
}

const PERMISSION_ACTION = {
    FULL:'full_access',
    VIEW:'view_permission',
    CREATE:'create_permission',
    UPDATE:'edit_permission',
    DELETE:'delete_permission',
    LIST:'list_permission'
}

export const PERMISSION ={
    PERMISSION_LIST,
     PERMISSION_STATUS,
      PERMISSION_ACTION
}